import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    files: [],
    status: "",
    error: null,
};

export const deleteUploadSlice = createSlice({
    name: "deleteUploadSlice",
    initialState,
    reducers: {
        setDeleteUploadFile: (state, action) => {
            state.files = [...state.files, action.payload];
        },
        resetDeleteUploadFile: (state) => {
            state.files = [];
        },
    },
});

export const selectDeleteUploadFiles = (state) => state.deleteUploadSlice.files;
export const { setDeleteUploadFile, resetDeleteUploadFile } = deleteUploadSlice.actions;